import React from 'react';
import {Button, Icon, GroupContainer, Title, Modal} from '@mc/ui-v4';
import {rffFormSubmit, WaitForQueryData} from '@mc/react-app-v4';
import {OpravneniConfiguration} from './OpravneniConfiguration';
import {LayerSettingsApi, LayerVO, RightsApi, UserRightsVO} from '../../../api';
import {useQuery, useQueryClient} from 'react-query';
import {CACHE_KEY_CATALOG_OPRAVNENI, CACHE_KEY_LAYER_TOPIC} from '../../../queryKeys';
import {NodeModel} from '@minoru/react-dnd-treeview';
import {restData} from '../../tree/TopicTreeMenu';
import {mcEdit} from '@mc/react-ui-icons';
import {NewEditKategorie} from './NewEditKategorie';
import {useAuth} from '@mc/react-auth';
import {isUserAdminOrMapioAdmin, isVlastnikOfAllLayers} from '../../../helpers/AuthRights';
import {LayerId} from '@mc/react-mapio';

type Props = {catalog: NodeModel<restData>; topicId?: string; catalogLayers: {[key: string]: LayerVO}};
export const CatalogConfiguration: React.FC<Props> = ({catalog, topicId, catalogLayers}) => {
    const {data: auth} = useAuth();
    const opravneniCatalogQuery = useQuery<UserRightsVO[]>(
        [CACHE_KEY_CATALOG_OPRAVNENI, catalog?.data?.catalogItemId],
        async () => (await RightsApi.getAllCatalogRights(catalog?.data?.catalogItemId)).data,
        {enabled: !!catalog?.data?.catalogItemId},
    );
    const queryClient = useQueryClient();
    return (
        <WaitForQueryData queries={[opravneniCatalogQuery]}>
            {() => {
                const opravneniData = opravneniCatalogQuery.data;
                let topicLayersIds: Set<LayerId> = new Set();

                opravneniData?.map(({layers}) => {
                    layers.forEach(({layer}) => {
                        topicLayersIds.add(layer.id);
                    });
                });

                const topicLayersData = Object.values(catalogLayers)?.filter(layer => topicLayersIds?.has(layer.id));
                const currentPracovnikRights = opravneniCatalogQuery.data?.find(right => right.pracovnik?.pracovnikId === auth?.pracovnikId);
                const isVlastnikOfCatalog = isUserAdminOrMapioAdmin(auth) || isVlastnikOfAllLayers(currentPracovnikRights, Array.from(topicLayersIds));
                return (
                    <GroupContainer
                        title={
                            <Title
                                inverse
                                intent={'inherit'}
                                extraLeft
                                extra={
                                    isVlastnikOfCatalog && (
                                        <Button
                                            style={'link'}
                                            onClick={() =>
                                                Modal.show(({onClose}) => (
                                                    <NewEditKategorie
                                                        initialValues={{nazev: catalog.text}}
                                                        onClose={onClose}
                                                        isEdit
                                                        onSubmit={async data => {
                                                            return await rffFormSubmit(async () => {
                                                                await LayerSettingsApi.updateCatalogItem(catalog.data?.catalogItemId, {
                                                                    catalogItemId: catalog.data?.catalogItemId,
                                                                    label: data.nazev,
                                                                    catalogItemParentId: Number(catalog.parent),
                                                                });
                                                                await queryClient.invalidateQueries([CACHE_KEY_LAYER_TOPIC, topicId]);
                                                                onClose();
                                                            });
                                                        }}
                                                    />
                                                ))
                                            }
                                            icon={<Icon icon={mcEdit} />}
                                        />
                                    )
                                }
                            >
                                {catalog.text}
                            </Title>
                        }
                    >
                        <div className={'config-menu-overflow'}>
                            <OpravneniConfiguration opravneniItems={opravneniData} topicLayers={topicLayersData} showLayers />
                        </div>
                    </GroupContainer>
                );
            }}
        </WaitForQueryData>
    );
};
